import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { PolicyConditions } from '@app/core/types/policy.types';

type PolicyResponse = PolicyConditions & { data?: PolicyConditions };

@Injectable({ providedIn: 'root' })
export class PolicyService {
  private readonly http = inject(HttpClient);

  private readonly consentUrl = `${environment.url.api}/consent`;
  private readonly userUrl = `${environment.url.api}/user/me`;

  getPrivacyPolicy(): Observable<PolicyConditions> {
    return this.http
      .get<PolicyResponse>(`${this.consentUrl}/privacypolicy/current`)
      .pipe(map((response) => response?.data ?? response));
  }

  getTermsAndConditions(): Observable<PolicyConditions> {
    return this.http
      .get<PolicyResponse>(`${this.consentUrl}/termsconditions/current`)
      .pipe(map((response) => response?.data ?? response));
  }

  acceptTermsAndConditions(termsConditionsId: string): Observable<void> {
    return this.http.post<void>(`${this.userUrl}/consent`, {
      termsConditionsId,
    });
  }
}
